import { EMBED_LINKS } from 'containers/ProductTour/constants';

export const CHECKOUT_JOURNEY_PATH = 'checkout-journey';

export const CASHFREE_DOC_PAYMENTS = 'https://www.cashfree.com/docs/payments';
export const CASHFREE_DOCS_GATEWAY_END_POINTS =
  'https://www.cashfree.com/docs/api-reference/payments/latest/overview#payment-gateway-end-points';

export const GUIDE_URL =
  'https://www.cashfree.com/docs/payments/online/webhooks/configure';
export const HERE_GUIDE_URL =
  'https://www.cashfree.com/docs/payments/online/webhooks/overview';

export const VISIBILITY_CONFIG = {
  '/checkout-journey/': { showPrevious: false, showDefer: true },
  '/checkout-journey/success/': { showPrevious: false, showDefer: false },
};

export const PLATFORM_API_REFERENCE =
  'https://www.cashfree.com/docs/payments/online/element/overview';

export const MODAL_NAMES = {
  WEB_CHECKOUT_VIDEO: 'web-checkout-video',
  MOBILE_CHECKOUT_VIDEO: 'mobile-checkout-methods',
};

export const IntegrationEvents = {
  SBOX_API_KEYS: 'SBOX_API_KEYS',
  SBOX_FIRST_TXN: 'SBOX_FIRST_TXN',
  SBOX_WEBHOOKS: 'SBOX_WEBHOOKS',
  PROD_API_KEYS: 'PROD_API_KEYS',
  PROD_FIRST_TXN: 'PROD_FIRST_TXN',
  PROD_WEBHOOKS: 'PROD_WEBHOOKS',
  WHITELIST_SITE: 'WHITELIST_SITE',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  SETTLEMENT_BANK_DETAILS: 'SETTLEMENT_BANK_DETAILS',
  CUSTOMISE_CHECKOUT: 'CUSTOMISE_CHECKOUT',
  TRY_IT_OUT: 'TRY_IT_OUT',
};

export const apiDocsReference = {
  WEB: `${CASHFREE_DOC_PAYMENTS}/online/web/redirect`,
  MOBILE_ANDROID: `${CASHFREE_DOC_PAYMENTS}/online/mobile/android`,
  MOBILE_IOS: `${CASHFREE_DOC_PAYMENTS}/online/mobile/ios`,
  MOBILE_HYBRID_FLUTTER: `${CASHFREE_DOC_PAYMENTS}/online/mobile/flutter`,
  MOBILE_HYBRID_REACTNATIVE: `${CASHFREE_DOC_PAYMENTS}/online/mobile/react-native`,
  MOBILE_HYBRID_CORDOVA: `${CASHFREE_DOC_PAYMENTS}/online/mobile/cordova`,
};

export const hybridOptions = {
  flutter: {
    video: EMBED_LINKS.API_INTEGRATION_MOBILE_HYBRID_FLUTTER,
    apiReference: apiDocsReference.MOBILE_HYBRID_FLUTTER,
  },
  reactNative: {
    video: EMBED_LINKS.API_INTEGRATION_MOBILE_HYBRID_REACTNATIVE,
    apiReference: apiDocsReference.MOBILE_HYBRID_REACTNATIVE,
  },
  cordova: {
    video: EMBED_LINKS.API_INTEGRATION_MOBILE_HYBRID_CORDOVA,
    apiReference: apiDocsReference.MOBILE_HYBRID_CORDOVA,
  },
};

export const INTEGRATION_STATUS = {
  NOT_COMPLETED: 'NOT_COMPLETED',
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
};
